import Vue from "vue";
import App from "./App.vue";
import vuetify from "@/plugins/vuetify";
import router from "./router";
import store from "./store";
import VueDateFns from "vue-date-fns";

import service from "@/services/service.js";

Vue.config.productionTip = false;
Vue.use(VueDateFns);
Vue.mixin({
  methods: {
    formatDateTime(value) {
      if (value instanceof Date) {
        return this.$date(value, "yyyy/MM/dd HH:mm");
      } else if (value) {
        return this.$date(new Date(value), "yyyy/MM/dd HH:mm");
      }
    },
    formatDate(value) {
      if (value instanceof Date) {
        return this.$date(value, "yyyy-MM-dd");
      } else if (value) {
        return this.$date(new Date(value), "yyyy-MM-dd");
      }
    },
    sortVersion(x, y) {
      if (!!x && !!y) {
        // x - row1 value for column
        // y - row2 value for column
        var xArr = x.split(".");
        var yArr = y.split(".");
        for (var i = 0; i < xArr.length; i++) {
          var result = this.sortNumber(parseInt(xArr[i]), parseInt(yArr[i]));
          if (result != 0) {
            return result;
          }
        }
      }
      return 0;
    },
    sortNumber(x, y) {
      return x < y ? -1 : x > y ? 1 : 0;
    },
    getCurrency() {
      if (
        window.location.origin.toLowerCase() ==
        "https://monadmanagementau.monadticketing.com"
      ) {
        return "AUD";
      } else {
        return "GBP";
      }
    }
  }
});

new Vue({
  router,
  store,
  created() {
    const sessionString = localStorage.getItem("session"); // grab user data from local storage
    if (sessionString) {
      // check to see if there is indeed a user
      const session = JSON.parse(sessionString); // parse user data into JSON
      this.$store.commit("SET_SESSION", session); // restore user data with Vuex
      service.setAuthHeader(session); // set the headers
      service.getCurrentVersions().then(response => {
        this.$store.dispatch("setCurrentVersions", response.data[0]);
      });
    }
    service.setErrorHandler(function errorHandler(error, store) {
      if (error.response.status === 401) {
        // if we catch a 401 error and are logged in
        //store.dispatch("logout"); // force a log out
        store.dispatch("addMessage", {
          message: error.response
        });
      } else {
        store.dispatch("addMessage", {
          message: error.response
        });
        console.log(error.response);
        throw error;
      }
    }, this.$store);
  },
  vuetify,
  render: h => h(App)
}).$mount("#app");
